module.exports = __webpack_public_path__ + "pg.8aa3495ff085d9d4d2f8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pg.svg
// module chunks = styles